// extracted by mini-css-extract-plugin
export default {"avatar":"initialAvatar_avatar__vRomd"};